import { useState } from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  ImageInput,
  ImageField,
  required,
  BooleanInput,
  SelectInput,
  FormDataConsumer,
} from "react-admin";
import { JoditEditorCustom } from "components/features/Partials/CustomComponents/JoditEditorCustom";
import { newsChoices, languageChoices, initialValues } from "utils/options";
import { ActiveCreateToolbar } from "components/features/Partials/CustomComponents/ActiveSaveToolbar";
import CustomDateInput from "common/components/Fields/CustomDateInput";

const CreateNews = () => {
  const [newContent, setContent] = useState(null);
  const currentDate = new Date().toISOString().split("T")[0];
  const setContentValue = newContent => {
    setContent(newContent);
  };
  const transform = data =>
    newContent !== null
      ? {
          ...data,
          content: newContent,
        }
      : null;

  return (
    <Create
      transform={transform}
      title="Създаване на новина към каталог"
    >
      <SimpleForm
        defaultValues={initialValues}
        toolbar={<ActiveCreateToolbar />}
      >
        <SelectInput
          label="Език"
          source="language"
          choices={languageChoices}
          validate={required()}
        />

        <TextInput
          label="Заглавие"
          source="title"
          validate={required()}
          fullWidth
          multiline
        />
        <SelectInput
          label="Тип"
          source="news_type"
          fullWidth
          validate={required()}
          choices={newsChoices}
          multiline
        />
        <TextInput
          label="Подзаглавие"
          source="sub_head"
          multiline
          fullWidth
        />
        <CustomDateInput
          label="Начална дата"
          source="starting_on"
          validate={required()}
          defaultValue={currentDate}
        />
        <CustomDateInput
          label="До дата"
          source="ending_on"
        />
        <CustomDateInput
          label="Дата на публикуване"
          source="date_beginning"
          validate={required()}
          defaultValue={currentDate}
        />
        <TextInput
          label="Кратко описание"
          source="short_description"
          multiline
          fullWidth
        />
        <TextInput
          label="Ключови думи"
          source="tags"
          fullWidth
          multiline
        />
        <FormDataConsumer>
          {({ formData }) => {
            return (
              <JoditEditorCustom
                value={formData?.content}
                onBlur={setContentValue}
              />
            );
          }}
        </FormDataConsumer>
        <ImageInput
          placeholder="Добавете снимка"
          label="Снимка"
          source="file"
          accept="image/*"
        >
          <ImageField
            source="src"
            title="title"
          />
        </ImageInput>
        <BooleanInput
          label="Скрита"
          source="is_hidden"
        />
      </SimpleForm>
    </Create>
  );
};

export default CreateNews;
